import mini from './mini'
let config = {
    mini

}

export default config